<script>
import Layout from '@layouts/main.vue'
import SubBubbleAgreementsContainer from '@/components/subBubbleAgreement/sub-bubble-agreements-container.vue'

export default {
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'Sub Bubble Agreements' }],
    }
  },
  components: { Layout, SubBubbleAgreementsContainer },
  props: {
    clientGroupId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    isValidClientGroupId() {
      return !isNaN(this.clientGroupId)
    },
    clientGroupIdFormatted() {
      return this.isValidClientGroupId ? Number(this.clientGroupId) : null
    },
  },
}
</script>

<template>
  <Layout>
    <v-alert v-if="!isValidClientGroupId" type="warning" outlined>{{
      $t('general.invalidUrl')
    }}</v-alert>
    <SubBubbleAgreementsContainer
      v-else
      :client-group-id="clientGroupIdFormatted"
    />
  </Layout>
</template>
